module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture5-1caa38c3d5edc44605673a714942f61e.jpg";